const LeaveRoutes = [
    //Leave
    {
        path: '/leave/LeaveRequestForm/:id',
        component: () => import('@/views/Leave/LeaveRequestFormView.vue'),
        props: true
    },
    {
        path: '/leave/leave-request/',
        component: () => import('@/views/Leave/LeaveRequestView.vue'),
    },
    {
        path: '/leave/leave-record',
        component: () => import('@/views/Leave/LeaveRecordView.vue'),
    },
    {
        path: '/leave/leave-profile',
        component: () => import('@/views/Leave/LeaveProfileView.vue'),
    },
    {
        path: '/leave/leave-profile-type',
        component: () => import('@/views/Leave/LeaveProfile/Setup.vue'),
    },
    {
        path: '/leave/report',
        component: () => import('@/views/Leave/Report/index.vue'),
    },
    {
        path: '/Leave/LeaveFlow',
        component: () => import('@/views/Leave/LeaveFlowView.vue'),
    },
    {
        path: '/Leave/LeaveType',
        component: () => import('@/views/Leave/LeaveTypeView.vue'),
    },
    {
        path: '/leave/calenda',
        component: () => import('@/views/Leave/LeaveCalendar.vue'),
    },
]

export default LeaveRoutes;